import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import PageHeroTitle from '../components/PageHeroTitle'
import BottomImage from '../components/BottomImage'
import { usePois } from '../contexts/PoisContext'
import { setFlashMessage } from '../contexts/WebsiteContext'

const PoiTypePage = ({ Component, poiType }) => {
  const { t } = useTranslation()
  const { pois } = usePois()

  const filteredPois = pois.filter((poi) => poi.poiType.name === poiType)
  const pageName = `POI_TYPE_${poiType}`

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle
        title={t(`${pageName}_PAGE_TITLE`)}
        description={t(`${pageName}_PAGE_DESCRIPTION`)}
      />

      <div className="container section py-4">
        <p className="lead">{t(`${pageName}_PAGE_DETAILS`)}</p>
        {filteredPois.length > 0 && <Component pois={filteredPois} />}
      </div>

      <div className="container">
        <BottomImage name={pageName} />
      </div>

      <Footer />
    </div>
  )
}

export default PoiTypePage
